import { render } from "./AchievementCard.vue?vue&type=template&id=83a29524"
import script from "./AchievementCard.vue?vue&type=script&lang=js"
export * from "./AchievementCard.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__